module.exports = __webpack_public_path__ + "img/bg.128492a3.png";